import { loadModules } from "esri-loader";

const initMap = async ({
  mapDiv,
  setMapZoom,
  setZoomLvl,
  viewMap,
  role,
}: any) => {
  const [Map, MapView, urlUtils, MapImageLayer, GraphicsLayer, LayerList] =
    await loadModules([
      "esri/Map",
      "esri/views/MapView",
      "esri/core/urlUtils",
      "esri/layers/MapImageLayer",
      "esri/layers/GraphicsLayer",
      "esri/widgets/LayerList",
    ]);

  const url = process.env.REACT_APP_MAP_API;
  const proxy = process.env.REACT_APP_MAP_PROXY;
  let layerList;
  const mapServer = `${url}/PTT_SHIP/PTT_SHIP_MAP/MapServer`;
  const proxyUrl = `${proxy}/${btoa(
    "user=trackingmove&system=map"
  )}/api/AppProxy`;

  urlUtils.addProxyRule({
    urlPrefix: url,
    proxyUrl,
  });
  let mapImageLayerIntegrate = new MapImageLayer({
    url: mapServer,
    sublayers: [
      { title: "Plant", id: 9, visible: true },
      {
        title: "Area",
        id: 8,
        visible: true,
      },
      {
        title: "อาคาร",
        id: 7,
        visible: true,
      },
      { title: "จุดจอดรถ", id: 6, visible: true },
      // {
      //   id: 5,
      //   visible: true,
      // },
      { title: "pipe Rack", id: 4, visible: true },
      { title: "pipe Bridge", id: 3, visible: true },
      {
        title: "ถนน",
        id: 2,
        visible: true,
      },
      {
        title: "ป้ายจราจร",
        id: 1,
        visible: true,
      },
      {
        title: "อุปกรณ์",
        id: 0,
        visible: true,
      },
    ],
  });

  let zoom = 17;
  if (role === "ths silom") zoom = 18;

  const restrictAreaLayer = new GraphicsLayer({
    title: "past-restrict-layer",
    id: "past-restrict-layer",
  });
  const pttGeometryLayer = new GraphicsLayer({
    title: "ptt-geometry-layer",
    id: "ptt-geometry-layer",
  });
  const pttGeometryTextLayer = new GraphicsLayer({
    title: "ptt-geometry-layer-text",
    id: "ptt-geometry-layer-text",
  });
  const employeeLayer = new GraphicsLayer({
    title: "employee-layer",
    id: "employee-layer",
  });
  let baseMap = "satellite";
  let minZoom = 16;
  if (viewMap === "satellite") {
    baseMap = "satellite";
    minZoom = 16;
  } else if (viewMap === "streets-vector") {
    baseMap = "streets-vector";
    minZoom = 15;
  } else {
    baseMap = "streets-night-vector";
    minZoom = 15;
  }
  const map = new Map({
    basemap: baseMap,
    layers: [
      mapImageLayerIntegrate,
      restrictAreaLayer,
      pttGeometryLayer,
      pttGeometryTextLayer,
      employeeLayer,
    ],
  });

  const view = new MapView({
    map,
    container: mapDiv.current,
    zoom,
    center: [101.14724047605345, 12.720144961950934],
    constraints: {
      minZoom,
    },
    rotation: 58,
  });

  layerList = new LayerList({
    view: view,
  });

  view.watch("zoom", (newValue: number) => {
    setMapZoom(newValue);
    if (newValue >= 16 && newValue < 17) setZoomLvl("PLANT");
    else if (newValue >= 17 && newValue <= 18) setZoomLvl("AREA");
    else if (newValue > 18) setZoomLvl("SUBAREA");
  });

  return [map, view, layerList];
};

export default initMap;
